import { axiosApi } from "../../../../../../../api/dbAxios";

export const updateDocumentTag = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
  fields: { tags: string[] },
) => {
  try {
    const response = await axiosApi.patch(
      `/items/${regulatorCode}/${case_no}/`,
      fields,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating document tags:", error);
    return {};
  }
};
